import * as Bowser from "bowser";

const browser = Bowser.getParser(window.navigator.userAgent);
const isNotSupported = browser.satisfies({
    chrome: "<20",
    firefox: "<31",
    opera: "<22",
    safari: "<9",
    edge: "<=44.17763.1.0",
    chromium: "<20",
    "android browser": "<3.10",
    ie: "<=11",
});

if (isNotSupported) {
    window.location.href = window.location.protocol + "//" + window.location.host + "/unsupported.html";
} else {
    import("src/app");
}
